import React from 'react';
import PropTypes from 'prop-types';
import { Accordion } from '@appcues/sonar';
import { BlockContentShape } from 'entities/block/shape';
import {
  Content,
  Style,
  SizeSpacing,
  ThemeVariantSelect,
} from 'components/SideBarSettings/Shared';
import ContentActions from 'components/SideBarSettings/Content/ContentActions';
import { BUTTON } from 'lib/block/block';

export function ButtonSettings({
  content,
  contentWithVariations,
  blockType,
  onChange,
}) {
  const { id: blockId } = content ?? {};

  return (
    <Content>
      <Accordion.Root
        collapsible="true"
        defaultValue={['style']}
        type="multiple"
      >
        <ThemeVariantSelect
          type={blockType}
          content={content}
          contentWithVariations={contentWithVariations}
          onChange={onChange}
        />
        <Style content={content} onChange={onChange} />
        <SizeSpacing
          content={content}
          onChange={onChange}
          hasMargin
          hasPadding
        />
        <ContentActions blockId={blockId} context={BUTTON} />
      </Accordion.Root>
    </Content>
  );
}

ButtonSettings.propTypes = {
  content: BlockContentShape,
  contentWithVariations: BlockContentShape,
  blockType: PropTypes.string,
  onChange: PropTypes.func,
};

export default ButtonSettings;
